export class CoordiateModel {
	x: number;
	y: number;
}

export class CanvasStyleModel {
	bgColor: string;
	bgOpacity: number;
	borderColor: string;
	borderWidth: number;
	bgOverColor: string;
	bgOverOpacity: number;
	borderOverColor: string;
	borderOverWidth: number;
}



// WEBPACK FOOTER //
// /home/rubylover/Work/new_vin_photo/site/web/src/app/core/models.ts